import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { DayEndService } from 'src/app/services/DayEnd.service';
import { GeneralService } from 'src/app/services/general.service';
import { PosSettingsService } from 'src/app/services/pos-settings.service';
import { RentalSettingService } from 'src/app/services/RentalSetting.service';
import { UserService } from 'src/app/services/User.service';
import { CommonCalculatorService } from 'src/app/Shared/commonCalculators.service';
import { EActionTypes, EDenominations, EDenominationsListOfValues, ELovTypes, EUserSecurityFunctionID } from 'src/app/Shared/enum';
import { IDayEndDetailsModel } from 'src/app/Shared/Interfaces/IDayEndProcess';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { ITwoDigitDecimalInput, IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import { TwoDigitDecimalDirective } from 'src/app/Shared/restrictToTwoDigitDecimal.directive';
import { ANGULAR_MODULES, OperationsComponent, SYNCFUSION_MODULES, TopBarComponent } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ops-day-end-process',
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, OperationsComponent, TwoDigitDecimalDirective, TopBarComponent, UserPermissionHandlerDirective, LoaderComponent],
  providers: [DatePipe, CurrencyPipe],
  standalone: true,
  templateUrl: './ops-day-end-process.html',
  styleUrl: './ops-day-end-process.scss'
})

export class OpsDayEndProcess implements OnInit, OnDestroy {

  @ViewChild('gridCoinsBills') public gridCoinsBills?: GridComponent;
  @ViewChild('gridCloseAmt') public gridCloseAmt?: GridComponent;
  private destroy$ = new Subject<void>();
  loaderIcon$ = new BehaviorSubject<boolean>(false);
  isCollapsed = true;
  disProcDayEnd: boolean = false;
  dayEndForm!: FormGroup;
  listCoinsAndBills = [];
  gridClosingAmt: any[] = [];
  allDayEndData: any[] = [];
  decimalRestrictInput: ITwoDigitDecimalInput = {
    Length: 7,
    IsCurrency: true,
    DefaultMinimum: false,
    MinimumValue: '0.00',
    MaximumValue: '9999999.99',
    WholeValue: false,
  };
  gridTotal = 0;
  fromDate: Date | null = null;
  toDate: Date | null = null;
  userName = '';
  activeTab: 'All' | 'Pending' | 'Completed' = 'All';
  dayEndData: any[] = [];
  userList: any[] = [];
  viewPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.DayEndProcess, Action: EActionTypes.VIEW };
  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.DayEndProcess, Action: EActionTypes.CREATE };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID.DayEndProcess, Action: EActionTypes.EDIT };
  public createRight = false;
  public editRight = false;
  public isSuperUser: boolean = false;
  coinsandBilsId = 0;
  passcode: string = '';
  enteredBy: number = null;
  pendingDayEnd: (() => void) | null = null;
  minExpiryDate: Date = new Date();
  maxExpiryDate: Date = new Date();
  marketCurrentDate!: Date;
  dayendRowData;
  routeFromTrans = false;
  isCashRoundingEnabled: boolean = false;
  isRentalCashRoundingEnabled: boolean = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private dayEndService: DayEndService,
    private generalService: GeneralService,
    private posSettingsService: PosSettingsService,
    private rentalService: RentalSettingService,
    private router: Router,
    private commonCalculatorService: CommonCalculatorService,
    private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
  ) { }

  ngOnInit(): void {
    this.userName = this.userService.getLoggedInUserName();
    this.enteredBy = this.userService.getLoggedInUserId();
    if (this.router.url.includes('/trans')) {
      this.routeFromTrans = true;
    }
    this.loadMarketCurrentDate();
    this.initForm();
    this.loadUserList();
    this.getPosAndRentalSettings();
    this.getUserPermissionForDayEnd();
    this.checkIfSuperUser();
    this.loadDayEndTerminals();
    this.getDenominations();
  }

  loadMarketCurrentDate(): void {
    this.generalService.GetMarketCurrentTime().pipe(takeUntil(this.destroy$)).subscribe({
      next: (marketTime: string) => {
        const marketDate = marketTime.split('T')[0];
        this.marketCurrentDate = this.toLocalDate(marketDate);
        this.maxExpiryDate = this.marketCurrentDate;
        this.getDefaultDateRange();
      },
      error: (err) => {
        console.error("Error fetching market time", err);
      }
    });
  }

  initForm(): void {
    this.dayEndForm = this.fb.group({
      UserId: [0, Validators.required],
      UserName: [],
      TerminalName: ['', Validators.required],
      Date: ['', Validators.required],
      IsCancel: [false],
      OcaNumSlNo: [0],
      OpeningCashAmount: [],
      PettyCashAmount: [],
      RoundingOffAmount: [],
      ClosingAmountDetails: this.fb.group({
        UserCash: [0],
        SystemCash: [0],
        DifferenceCash: [0],
        DiffCashReason: [''],
        UserCheckAmt: [0],
        SystemCheckAmt: [0],
        DifferenceCheckAmt: [0],
        DiffCheckAmtReason: [''],
        UserTravCheckAmt: [0],
        SystemTravCheckAmt: [0],
        DifferenceTravCheckAmt: [0],
        DiffTravCheckAmtReason: [''],
        UserGiftCertAmt: [0],
        SystemGiftCertAmt: [0],
        DifferenceGiftCertAmt: [0],
        DiffGiftCertAmtReason: [''],
        SystemCashRent: [0],
        SystemNetCash: [0],
        SystemNetCheck: [0],
        SystemCheckRent: [0],
        CardClosingAmounts: this.fb.array([])
      })
    });
  }

  loadUserList() {
    this.userService.getUserList().pipe(takeUntil(this.destroy$)).subscribe({
      next: (users: any) => {
        this.userList = users.filter(u => !u.UserInactive);
      },
      error: (err) => {
        console.error('Failed to load user list', err);
      }
    });
  }

  getPosAndRentalSettings() {
    this.posSettingsService.getPosSettings().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this.isCashRoundingEnabled = res?.OtherSettings?.IsPOSCashRounding ?? false;
      },
      error: (err) => {
        console.error('Failed to load pos settings', err);
      }
    });

    this.rentalService.getRentalSettings().pipe((takeUntil(this.destroy$))).subscribe({
      next: (res: any) => {
        this.isRentalCashRoundingEnabled = res?.PaymentSettings?.IsRentalCashRounding ?? false;
      },
      error: err => {
        console.error('Failed to load rental settings', err);
      }
    });
  }

  get isAnyCashRoundingEnabled(): boolean {
    return this.isCashRoundingEnabled || this.isRentalCashRoundingEnabled;
  }

  getUserPermissionForDayEnd(): void {
    setTimeout(() => {
      const userRightsForDayEndProcess = this.generalService.getUserPermissionsForModule(EUserSecurityFunctionID.DayEndProcess);
      this.createRight = userRightsForDayEndProcess.CreateRight;
      this.editRight = userRightsForDayEndProcess.EditRight;
    }, 300);
  }

  checkIfSuperUser(): void {
    this.generalService.GetUserPermission().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.isSuperUser = res?.UserRoles?.SuperUser ?? false;
        //console.log('Is SuperUser:', this.isSuperUser);
      },
      error: (err) => {
        console.error('Error fetching user permissions:', err);
        this.isSuperUser = false;
      }
    });
  }

  get CardClosingAmounts(): FormArray {
    return this.dayEndForm.get('ClosingAmountDetails.CardClosingAmounts') as FormArray;
  }

  getDefaultDateRange(): void {
    const today = this.marketCurrentDate;
    const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    this.minExpiryDate = lastMonth;
    this.toDate = today;
    this.fromDate = lastMonth;
  }

  loadDayEndTerminals(fromDate?: string | null, toDate?: string | null): void {
    this.loaderIcon$.next(true);
    this.dayEndService.getDayEndTerminals(this.userName, fromDate, toDate).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data) => {
        this.allDayEndData = data.map((item: any) => ({
          ...item,
          Date: item.OpeningCashDate ? this.toLocalDate(item.OpeningCashDate) : null
        }));
        this.applyDayEndFilter(this.activeTab);

        if (this.routeFromTrans) {
          this.generalService.getDayendRowDataForTrans().subscribe(value => {
            if (value != null) {
              this.dayendRowData = value; // 
              var slNo = this.allDayEndData.find(e => e.Terminal == this.dayendRowData.Terminal
                && e.UserId == this.dayendRowData.UserId && e.OpeningCashDate == this.dayendRowData.OpeningCashDate)?.OcaNumSlNo;
              this.dayendRowData.OcaNumSlNo = slNo;
              this.onProcessDayEnd(this.dayendRowData);
              //this.generalService.setDayendRowDataForTrans(null);
            }
          });
        }

        this.loaderIcon$.next(false);
      },
      error: (err) => {
        this.loaderIcon$.next(false);
        console.error('Error loading day-end terminals by date', err);
      }
    });
  }

  toLocalDate(dateString: string): Date {
    const [y, M, d] = dateString.split('-').map(Number);
    return new Date(y, M - 1, d);
  }

  onDateChange() {
    if (this.fromDate && this.toDate) {
      this.minExpiryDate = this.fromDate;
      const formattedFrom = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
      const formattedTo = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
      this.loadDayEndTerminals(formattedFrom, formattedTo);
    } else {
      this.loadDayEndTerminals();
    }
  }

  getDenominations() {
    this.generalService.getListOfValuesByType(ELovTypes.Denominations).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        const denominations = res as any[];
        this.listCoinsAndBills = denominations.map(denomination => {
          denomination['Count'] = 0;
          denomination['Amount'] = 0;
          return denomination;
        });
      },
      error: err => console.error('Failed to load denominations', err)
    });
  }

  onProcessDayEnd(rowData: any) {
    if (!rowData.UserId || !rowData.Terminal || !rowData.OpeningCashDate) {
      console.error('Missing data for day-end API');
      return;
    }

    const processDayEnd = () => {
      this.disProcDayEnd = true;
      this.loaderIcon$.next(true);
      this.dayEndService.getDayEndDetails(rowData.UserId, rowData.Terminal, rowData.OpeningCashDate, rowData.OcaNumSlNo)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: IDayEndDetailsModel) => {
            this.dayEndForm.patchValue({
              UserId: res.UserId,
              UserName: res.UserName,
              TerminalName: res.TerminalName,
              Date: res.Date,
              IsCancel: false,
              OcaNumSlNo: res.OcaNumSlNo,
              OpeningCashAmount: res.OpeningCashAmount,
              PettyCashAmount: res.PettyCashAmount ?? 0,
              RoundingOffAmount: res.RoundingOffAmount ?? 0
            });

            this.formatFormControlValue(this.dayEndForm, 'OpeningCashAmount');
            this.formatFormControlValue(this.dayEndForm, 'PettyCashAmount');
            this.formatFormControlValue(this.dayEndForm, 'RoundingOffAmount');
            this.clearGridCount();
            this.coinsandBilsId = 0;

            if (res.CoinsAndBills) {
              this.coinsandBilsId = res.CoinsAndBills.CoinsBillId;
              this.listCoinsAndBills.forEach(li => {
                switch (li.Name) {
                  case EDenominationsListOfValues.Pennies: li.Count = res.CoinsAndBills?.Count1 ?? 0; li.Amount = li.Count * 0.01; break;
                  case EDenominationsListOfValues.Nickels: li.Count = res.CoinsAndBills?.Count2 ?? 0; li.Amount = li.Count * 0.05; break;
                  case EDenominationsListOfValues.Dimes: li.Count = res.CoinsAndBills?.Count3 ?? 0; li.Amount = li.Count * 0.10; break;
                  case EDenominationsListOfValues.Quarter: li.Count = res.CoinsAndBills?.Count4 ?? 0; li.Amount = li.Count * 0.25; break;
                  case EDenominationsListOfValues['Half Dollars']: li.Count = res.CoinsAndBills?.Count5 ?? 0; li.Amount = li.Count * 0.5; break;
                  case EDenominationsListOfValues['Dollar Coins']: li.Count = res.CoinsAndBills?.Count6 ?? 0; li.Amount = li.Count * 1; break;
                  case EDenominationsListOfValues['$1 Bills']: li.Count = res.CoinsAndBills?.Count7 ?? 0; li.Amount = li.Count * 1; break;
                  case EDenominationsListOfValues['$2 Bills']: li.Count = res.CoinsAndBills?.Count8 ?? 0; li.Amount = li.Count * 2; break;
                  case EDenominationsListOfValues['$5 Bills']: li.Count = res.CoinsAndBills?.Count9 ?? 0; li.Amount = li.Count * 5; break;
                  case EDenominationsListOfValues['$10 Bills']: li.Count = res.CoinsAndBills?.Count10 ?? 0; li.Amount = li.Count * 10; break;
                  case EDenominationsListOfValues['$20 Bills']: li.Count = res.CoinsAndBills?.Count11 ?? 0; li.Amount = li.Count * 20; break;
                  case EDenominationsListOfValues['$50 Bills']: li.Count = res.CoinsAndBills?.Count12 ?? 0; li.Amount = li.Count * 50; break;
                  case EDenominationsListOfValues['$100 Bills']: li.Count = res.CoinsAndBills?.Count13 ?? 0; li.Amount = li.Count * 100; break;
                }
              });
              setTimeout(() => {
                this.gridCoinsBills?.refreshColumns();
              }, 0);
            }

            this.flattenDayEndDataForGrid(res);
            this.loaderIcon$.next(false);
          },
          error: (err) => {
            this.loaderIcon$.next(false);
            console.error('Failed to fetch day-end details', err);
          }
        });
    };
    if (rowData.DayEndStatus === 'Completed') {
      this.pendingDayEnd = processDayEnd; // store for later call
      this.openModalById('authModal');
    } else {
      processDayEnd();
    }
  }

  submitAuth() {
    const passcode = this.passcode;
    const userId = this.enteredBy;
    this.loaderIcon$.next(true);
    this.generalService.authenticatePasscodeForUsers(userId, passcode).pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res && res.Success) {
            this.loaderIcon$.next(false);
            this.closeModalById('authModal');
            if (this.pendingDayEnd) {
              this.pendingDayEnd();
              this.pendingDayEnd = null;
            }
          } else {
            this.pendingDayEnd = null;
            this.loaderIcon$.next(false);
            Swal.fire({
              icon: 'error',
              title: 'Invalid Passcode',
              text: 'Please enter a valid passcode to proceed.',
              confirmButtonText: 'OK',
            });
          }
          this.passcode = "";
          this.enteredBy = null;
        },
        error: (err) => {
          this.loaderIcon$.next(false);
          console.error('Authentication failed', err);
        }
      });
  }

  flattenDayEndDataForGrid(dayEndData: any) {
    const closing = dayEndData.ClosingAmount;
    this.gridClosingAmt = [];
    const formatZero = () => 0;
    const calcDifference = (net: number, actual?: number | null) => {
      return actual != null ? net - actual : net;
    };
    // Cash
    const cashNet = (closing.CashRent ?? 0) + (closing.CashPOS ?? 0);
    this.gridClosingAmt.push({
      type: 'CASH',
      terminalRent: closing.CashRent,
      terminalPOS: closing.CashPOS,
      netTerminal: cashNet,
      actualAmount: closing.UserCash ?? formatZero(),
      difference: calcDifference(cashNet, closing.UserCash),
      reason: closing.DiffCashReason ?? '',
      typeNumber: 0,
    });
    // Check
    const checkNet = (closing.CheckAmtRent ?? 0) + (closing.CheckAmtPOS ?? 0);
    this.gridClosingAmt.push({
      type: 'CHECK',
      terminalRent: closing.CheckAmtRent,
      terminalPOS: closing.CheckAmtPOS,
      netTerminal: checkNet,
      actualAmount: closing.UserCheck ?? formatZero(),
      difference: calcDifference(checkNet, closing.UserCheck),
      reason: closing.DiffCheckReason ?? '',
      typeNumber: 0,
    });
    // Traveller's Check
    const travNet = closing.TravCheckAmtPOS ?? 0;
    this.gridClosingAmt.push({
      type: 'TRAVELLERS CHECK',
      terminalRent: 0,
      terminalPOS: closing.TravCheckAmtPOS,
      netTerminal: travNet,
      actualAmount: closing.UserTravCheckAmt ?? formatZero(),
      difference: calcDifference(travNet, closing.UserTravCheckAmt),
      reason: closing.DiffTravCheckAmtReason ?? '',
      typeNumber: 0,
    });
    // Gift 
    const giftNet = closing.GiftCertAmtPOS ?? 0;
    this.gridClosingAmt.push({
      type: 'GIFT CERTIFICATE',
      terminalRent: 0,
      terminalPOS: closing.GiftCertAmtPOS,
      netTerminal: giftNet,
      actualAmount: closing.UserGiftAmt ?? formatZero(),
      difference: calcDifference(giftNet, closing.UserGiftAmt),
      reason: closing.DiffGitAmtReason ?? '',
      typeNumber: 0,
    });
    // Credit Card Payments 
    const ccPayments = closing.CreditCardTypePayments ?? [];
    ccPayments.forEach(cc => {
      if (!cc || !cc.CreditCardTypeName) return;
      const ccNet = (cc.CCRentAmount ?? 0) + (cc.CCPOSAmount ?? 0);
      this.gridClosingAmt.push({
        type: cc.CreditCardTypeName.toUpperCase(),
        terminalRent: cc.CCRentAmount ?? 0,
        terminalPOS: cc.CCPOSAmount ?? 0,
        netTerminal: ccNet,
        actualAmount: cc.UserCCAmt ?? formatZero(),
        difference: calcDifference(ccNet, cc.UserCCAmt),
        reason: cc.DiffCCReason ?? '',
        typeNumber: cc.CardTypeNumber ?? 0
      });
    });
  }

  calculateTotalCost(data, args): void {
    const count = args.target.value ?? 0;
    let denomination = 0;
    switch (data.Name) {
      case EDenominationsListOfValues.Pennies: denomination = EDenominations.Pennies; break;
      case EDenominationsListOfValues.Nickels: denomination = EDenominations.Nickels; break;
      case EDenominationsListOfValues.Dimes: denomination = EDenominations.Dimes; break;
      case EDenominationsListOfValues.Quarter: denomination = EDenominations.Quarter; break;
      case EDenominationsListOfValues['Half Dollars']: denomination = EDenominations['Half Dollars']; break;
      case EDenominationsListOfValues['Dollar Coins']: denomination = EDenominations['Dollar Coins']; break;
      case EDenominationsListOfValues['$1 Bills']: denomination = EDenominations['$1 Bills']; break;
      case EDenominationsListOfValues['$2 Bills']: denomination = EDenominations['$2 Bills']; break;
      case EDenominationsListOfValues['$5 Bills']: denomination = EDenominations['$5 Bills']; break;
      case EDenominationsListOfValues['$10 Bills']: denomination = EDenominations['$10 Bills']; break;
      case EDenominationsListOfValues['$20 Bills']: denomination = EDenominations['$20 Bills']; break;
      case EDenominationsListOfValues['$50 Bills']: denomination = EDenominations['$50 Bills']; break;
      case EDenominationsListOfValues['$100 Bills']: denomination = EDenominations['$100 Bills']; break;
    };

    this.gridCoinsBills.setCellValue(data.Name, 'Amount', this.commonCalculatorService.roundToDecimalPlace(denomination * count, 2));
    let totalAmount = this.listCoinsAndBills.reduce((sum, item) => this.commonCalculatorService.roundToDecimalPlace(sum + item.Amount, 2), 0);
    if (totalAmount > this.decimalRestrictInput.MaximumValue) {
      args.target.value = 0;
      this.gridCoinsBills.setCellValue(data.Name, 'Amount', 0);
      totalAmount = this.listCoinsAndBills.reduce((sum, item) => this.commonCalculatorService.roundToDecimalPlace(sum + item.Amount, 2), 0);
    }
    this.gridTotal = totalAmount > 0 ? (totalAmount) : 0;

    // Update CASH row in gridClosingAmt
    const cashRowIndex = this.gridClosingAmt.findIndex(row => row.type === 'CASH');
    if (cashRowIndex !== -1) {
      const net = (this.gridClosingAmt[cashRowIndex].terminalRent || 0) +
        (this.gridClosingAmt[cashRowIndex].terminalPOS || 0);
      const actualAmount = this.gridTotal;
      const difference = this.commonCalculatorService.roundToDecimalPlace(net - actualAmount, 2);
      this.gridCloseAmt.setCellValue(this.gridClosingAmt[cashRowIndex].type, 'actualAmount', actualAmount);
      this.gridCloseAmt.setCellValue(this.gridClosingAmt[cashRowIndex].type, 'difference', difference);
      this.gridClosingAmt[cashRowIndex].actualAmount = actualAmount;
      this.gridClosingAmt[cashRowIndex].difference = difference;
    }

    let selectedObject = this.listCoinsAndBills.find(l => l.Name == data.Name);
    selectedObject.Count = count;
  }

  onCountFocus(data: any) {
    if (data.Count === 0) {
      data.Count = null;
    }
  }

  onCountBlur(data: any) {
    if (!data.Count && data.Count !== 0) {
      data.Count = 0;
    }
  }

  formatCurrency(value: number | null): string {
    const num = value ?? 0;
    return `$${num.toFixed(2)}`;
  }

  onActualAmountFocus(event: any, data: any) {
    if (!data.actualAmount || data.actualAmount === 0) {
      event.target.value = '';
    } else {
      event.target.value = data.actualAmount.toString();
    }
  }

  onActualAmountBlur(event: any, data: any) {
    let raw = event.target.value;
    if (!raw || raw.trim() === '') {
      data.actualAmount = 0;
    } else {
      const numeric = parseFloat(raw.replace(/[^0-9.]/g, '')) || 0;
      data.actualAmount = numeric;
    }
    event.target.value = this.formatCurrency(data.actualAmount);
    this.updateDifference(data);
  }

  onActualAmountChange(valueStr: any, rowData: any) {
    const numeric = parseFloat((valueStr != null ? String(valueStr) : '0').replace(/[^0-9.]/g, '')) || 0;
    rowData.actualAmount = numeric;
    this.updateDifference(rowData);
  }

  updateDifference(rowData: any) {
    const net = (rowData.terminalRent || 0) + (rowData.terminalPOS || 0);
    const difference = this.commonCalculatorService.roundToDecimalPlace(net - rowData.actualAmount, 2);
    const rowIndex = this.gridClosingAmt.findIndex(row => row.type === rowData.type);
    if (rowIndex !== -1) {
      this.gridClosingAmt[rowIndex].difference = difference;
      this.gridClosingAmt[rowIndex].actualAmount = rowData.actualAmount;
      this.gridCloseAmt.setCellValue(this.gridClosingAmt[rowIndex].type, 'difference', difference);
    }
  }

  onReasonChange(value: string, rowData: any) {
    rowData.reason = value;
    const rowIndex = this.gridClosingAmt.findIndex(row => row.type === rowData.type);
    if (rowIndex !== -1) {
      this.gridClosingAmt[rowIndex].reason = value;
    }
  }

  formatFormControlValue(form: FormGroup, controlName: string) {
    const control = form.get(controlName);
    if (!control) return;
    const value = control.value ?? 0;
    const absValue = Math.abs(value);
    let formattedValue = this.currencyPipe.transform(absValue, '$', 'symbol', '1.2-2') || '$0.00';
    if (value < 0) {
      formattedValue = `(${formattedValue})`;
    }
    const input = document.querySelector<HTMLInputElement>(`input[formControlName="${controlName}"]`);
    if (input) input.value = formattedValue;
  }

  clearGridCount() {
    this.gridTotal = 0;
    this.listCoinsAndBills.forEach(li => {
      li.Count = 0;
      li.Amount = 0;
    });
    setTimeout(() => {
      this.gridCoinsBills?.refreshColumns();
    }, 0);
  }

  cancelDayEndProcess(rowData?: any): void {
    if (!rowData) {
      console.error('No row data provided for cancel DayEnd');
      return;
    }

    const payload: any = {
      UserId: rowData.UserId,
      TerminalName: rowData.Terminal,
      Date: rowData.OpeningCashDate,
      IsCancel: true,
      OcaNumSlNo: rowData.OcaNumSlNo,
      ClosingAmountDetails: rowData.ClosingAmountDetails && Object.keys(rowData.ClosingAmountDetails).length > 0
        ? rowData.ClosingAmountDetails
        : null
    };

    Swal.fire({
      title: `Are you sure you want to cancel DayEnd for terminal "${rowData.Terminal}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, cancel it',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.pendingDayEnd = () => {
          this.executeCancelDayEnd(payload);
        }; //store to call based on auth
        this.openModalById('authModal');
      }
    });
  }

  executeCancelDayEnd(payload: any): void {
    this.loaderIcon$.next(true);
    this.dayEndService.saveDayEndProcess(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res.Success) {
          this.loaderIcon$.next(false);
          this.toastr.success($localize`${res.Message}`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          const formattedFrom = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
          const formattedTo = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
          this.loadDayEndTerminals(formattedFrom, formattedTo);
        } else {
          this.loaderIcon$.next(false);
          this.toastr.error($localize`Error cancelling DayEnd`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
        }
      },
      error: (err) => {
        this.loaderIcon$.next(false);
        console.error('Failed to cancel DayEnd', err);
        this.toastr.error($localize`Failed to cancel DayEnd`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
      }
    });
  }

  saveDayEndProcess(): void {
    if (!this.dayEndForm.valid) {
      this.toastr.error('Please fill all required fields', 'Error', this.sharedHTMLSettings.ToasterConfig);
      return;
    }
    const formValue = this.dayEndForm.value;
    const closingAmounts = this.mapGridToClosingAmounts(this.gridClosingAmt, formValue.ClosingAmountDetails);
    this.dayEndForm.get('ClosingAmountDetails')?.patchValue(closingAmounts);
    // Check for differences without reason
    const missingReasons = this.gridClosingAmt
      .filter(row => row.difference && row.difference !== 0 && (!row.reason || row.reason.trim() === ''))
      .map(row => row.type);

    if (missingReasons.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Reason Required',
        text: `Please enter a valid reason for difference in Actual Amount and System Amount for: ${missingReasons.join(', ')}!`
      });
      return;
    }

    const hasAnyValue = this.listCoinsAndBills.some(item => Number(item.Count) > 0);

    const coinsAndBillsDetails = hasAnyValue
      ? this.listCoinsAndBills.reduce((acc, item, idx) => {
        const num = idx + 1;
        acc[`Coin${num}`] = item.Name;
        acc[`Count${num}`] = Number(item.Count) || 0; // default 0
        acc[`Val${num}`] = Number(item.Amount) || 0;  // default 0
        return acc;
      }, { CoinsBillId: this.coinsandBilsId ?? 0 } as any)
      : null;

    const payload = {
      ...this.dayEndForm.value,
      CoinsAndBills: coinsAndBillsDetails
    };

    Swal.fire({
      title: `Are you sure you want to save DayEnd for terminal "${payload.TerminalName}" ?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, save it',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        this.loaderIcon$.next(true);
        this.dayEndService.saveDayEndProcess(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res) => {
            if (res.Success) {
              this.loaderIcon$.next(false);
              this.toastr.success(res.Message, 'Success', this.sharedHTMLSettings.ToasterConfig);
              const formattedFrom = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
              const formattedTo = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
              this.generalService.setDayendRowDataForTrans(null);
              this.loadDayEndTerminals(formattedFrom, formattedTo);
              this.disProcDayEnd = false;
            } else {
              this.loaderIcon$.next(false);
              this.toastr.error('Error saving DayEnd', 'Error', this.sharedHTMLSettings.ToasterConfig);
            }
          },
          error: (err) => {
            this.loaderIcon$.next(false);
            console.error('Failed to save DayEnd', err);
            this.toastr.error('Failed to save DayEnd', 'Error', this.sharedHTMLSettings.ToasterConfig);
          }
        });
      }
    });
  }

  mapGridToClosingAmounts(gridClosingAmt: any[], closingAmountDetails: any): any {
    const mapped = { ...closingAmountDetails };

    const cardArray = this.dayEndForm.get('ClosingAmountDetails.CardClosingAmounts') as FormArray;
    cardArray.clear();

    gridClosingAmt.forEach(row => {
      const type = row.type;
      const reasonValue = (!row.difference || row.difference === 0) ? null : (row.reason || null);
      if (type === 'CASH') {
        mapped.UserCash = row.actualAmount ?? 0;
        mapped.SystemCash = row.netTerminal ?? 0;
        mapped.DifferenceCash = row.difference ?? 0;
        mapped.DiffCashReason = reasonValue;
        mapped.SystemCashRent = row.terminalRent ?? 0;
        mapped.SystemNetCash = row.netTerminal ?? 0;

      } else if (type === 'CHECK') {
        mapped.UserCheckAmt = row.actualAmount ?? 0;
        mapped.SystemCheckAmt = row.netTerminal ?? 0;
        mapped.DifferenceCheckAmt = row.difference ?? 0;
        mapped.DiffCheckAmtReason = reasonValue;
        mapped.SystemCheckRent = row.terminalRent ?? 0;
        mapped.SystemNetCheck = row.netTerminal ?? 0;

      } else if (type === 'TRAVELLERS CHECK') {
        mapped.UserTravCheckAmt = row.actualAmount ?? 0;
        mapped.SystemTravCheckAmt = row.netTerminal ?? 0;
        mapped.DifferenceTravCheckAmt = row.difference ?? 0;
        mapped.DiffTravCheckAmtReason = reasonValue;

      } else if (type === 'GIFT CERTIFICATE') {
        mapped.UserGiftCertAmt = row.actualAmount ?? 0;
        mapped.SystemGiftCertAmt = row.netTerminal ?? 0;
        mapped.DifferenceGiftCertAmt = row.difference ?? 0;
        mapped.DiffGiftCertAmtReason = reasonValue;

      } else {
        const cardForm = this.fb.group({
          CCType: row.typeNumber,
          CreditCardTypeName: type,
          CCUserAmount: row.actualAmount ?? 0,
          CCSystemAmount: row.netTerminal ?? 0,
          CCDifferenceAmount: row.difference ?? 0,
          CCDifferenceReason: reasonValue,
          SystemCCRentAmt: row.terminalRent ?? 0,
          SystemNetCCAmt: row.netTerminal ?? 0
        });
        cardArray.push(cardForm);
      }
    });
    return mapped;
  }

  restrictCurrencyInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9.]/g, '');
    const firstDotIndex = value.indexOf('.');
    if (firstDotIndex !== -1) {
      value = value.substring(0, firstDotIndex + 1) + value.substring(firstDotIndex + 1).replace(/\./g, '');
    }
    const parts = value.split('.');
    if (parts[0].length > 7) {
      parts[0] = parts[0].slice(0, 7);
    }
    if (parts[1]?.length > 2) {
      parts[1] = parts[1].slice(0, 2);
    }
    value = parts.join('.');
    input.value = value;
  }

  applyDayEndFilter(tab: 'All' | 'Pending' | 'Completed'): void {
    this.activeTab = tab;
    this.dayEndData =
      tab === 'Pending' ? this.allDayEndData.filter(i => i.DayEndStatus === 'Pending') :
        tab === 'Completed' ? this.allDayEndData.filter(i => i.DayEndStatus === 'Completed') :
          [...this.allDayEndData];
  }

  isToday(date: any): boolean {
    if (!date) return false;
    const d = new Date(date);
    const today = new Date();

    return d.getFullYear() === today.getFullYear() &&
      d.getMonth() === today.getMonth() &&
      d.getDate() === today.getDate();
  }

  closeModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    }

    this.passcode = "";
    this.enteredBy = null;

    document.body.classList.remove('modal-open');

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  openModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      let modal = window['bootstrap'].Modal.getInstance(modalEl);
      if (!modal) {
        modal = new window['bootstrap'].Modal(modalEl, { backdrop: 'static', keyboard: false });
      }
      modal.show();
    }
  }

  cancelDayEndProcessPage() {
    this.disProcDayEnd = false;
  }

  onDayEndPageCancel(): void {
    this.isCollapsed = true;
    this.router.navigate(['/dashboard']);
  }

  onBeforeOpen(args: any): void {
    if (!args || !args.target || !args.target.dataset || !args.target.dataset.content) {
      args.cancel = true;
    }
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
